import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../hooks";
import { dashboardState } from "../../redux/reducers/dashboardReducer";


import noEventImage from "../../assets/noEventImage.svg";
import { TwButton, TwContainer, TwMainLayout } from "../../components/tailwind";
import { clearLoadingData, loadingState, setSectionLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForEvent } from "../../utils/confighelpers";
import AddEditSellersModal from "./AddEditSellersModal";
import SellersTile from "./SellersTile";
import { PlusIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";

export default function SellersList({ navigation, profileFor, title }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const dashboardReduxState = useSelector(dashboardState);
  const [userToken] = useLocalStorage("userToken");
  const [sellersList, setSellersList] = React.useState([]);
  const [sellersModalOpen, setSellersModalOpen] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [selectedSellersData, setSelectedSellersData] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      setLoading(true)
      dispatch(setSectionLoading(true));
      await getListOfSellers();
      dispatch(clearLoadingData());
      setLoading(false)
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleSessionClick = async (id, serviceData) => {
    setSelectedSellersData(serviceData)
    setIsEdit(true)
    setSellersModalOpen(true);
  };


  const getListOfSellers = async () => {
    const manageClassesConfig = {
      method: "get",
      url: `${getUrlForEvent()}seller/list?getall=true`,
    };
    dispatch(setSectionLoading(true));
    const responce = await axiosInstance(manageClassesConfig);
    dispatch(setSectionLoading(false));
    if (responce.status === 200) {
      if (Array.isArray(responce.data.data)) {
        setSellersList(responce.data.data);
      }
    }
  };

  const renderSellers = (data) => {
    return (
      <ul className="space-y-4">
        {data.length > 0 ? (
          data.map((item, idx) => {
            const modifiedData = {
              item: item,
            };
            return (<SellersTile
              {...modifiedData}
              key={idx}
              handleSessionClick={() => {
                handleSessionClick(item._id, item);
              }}
              reload={() => {
                getListOfSellers();
              }}
            />);
          })
        ) : (
          <li className={"text-black text-center"}>{t("mySellers.noServicesAreAvailable")}</li>
        )}
      </ul>
    );
  };

  return (
    <TwMainLayout
      headTitle={t("pageTitle.mySellers")}
      headActions={[
        (<TwButton
          className="sm:min-w-32"
          onClick={() => {
            setSelectedSellersData({})
            setIsEdit(false)
            setSellersModalOpen(true);
          }}
        >
          <PlusIcon className='size-5' />&nbsp;&nbsp;{t("mySellers.addNewSellers")}
        </TwButton>),
      ]}
      children={<TwContainer className="">
        {sellersList.length ? (<div
          className={"sm:max-w-lg w-full"}
        >
          {renderSellers(sellersList)}
        </div>) : (loading == false && loadingReduxState.sectionLoading !== undefined && loadingReduxState.sectionLoading === false) ? (
          <div className="flex flex-col justify-center items-center gap-5 text-center h-full">
            <img
              className={"w-40 md:w-60"}
              src={noEventImage}
              alt={""}
            />
            <div className={"text-secondary text-lg font-bold mt-3"}>
              {t("mySellers.noSellersConfigured")}
            </div>
          </div>
        ) : ""}

        <AddEditSellersModal
          isEdit={isEdit}
          selectedSellersData={selectedSellersData}
          open={sellersModalOpen}
          handleClose={() => setSellersModalOpen(false)}
          handleUpdate={() => { setSellersModalOpen(false); getListOfSellers(); }}
        />
      </TwContainer>} />
  );
}
